import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };

const path = "business/common";

export const POST = async (data) => {
  return await axiosInstance(options).post(`${path}/ticket`, data);
};
export const GET = async (data) => {
  return await axiosInstance(options).get(`${path}/support-details`, data);
};